import styled from "styled-components";

const ProductsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`;
export default ProductsContainer;
